<template>
	<div class="layout-footer">
		<div>
			
			<p>Copyright &copy; {{thisYear}}, all rights reserved.</p>
			<p>{{siteName}}</p>
		</div>
		<div class="footer-icons">			
			<button class="p-link" @click="gotoTerms()">
				<em class="pi pi-shield"></em>
			</button>
			<button class="p-link" @click="gotoPrivacy()">
				<em class="pi pi-info-circle"></em>
			</button>
		</div>
	</div>
</template>

<script>
	export default {
		name: "AppFooter",
		data(){
			return {
				thisYear: null,
				siteName: process.env.VUE_APP_SYSTEM_NAME
			};
		},
		created(){
			var d = new Date();
			var n = d.getFullYear();
			this.thisYear=n+"";
		},

		methods:{
			gotoTerms() {
				this.$router.push({
								path: "/terms",
								});
			},
			gotoPrivacy() {
				this.$router.push({
								path: "/privacy",
								});
			},
			gotoProducts() {
				let supplierRefId = this.$retrieveSupplierRefId();
							if (supplierRefId) {
								this.$router.push({
								path: "/store/" + supplierRefId,
								});
							} else {
								this.$router.push({
								path: "/",
								});
							}
			},
			gotoStoreInfo() {
				let supplierRefId = this.$retrieveSupplierRefId();
							if (supplierRefId) {
								this.$router.push({
								path: "/contact/" + supplierRefId,
								});
							} else {
								this.$router.push({
								path: "/",
								});
							}
			}
		}
	}
</script>

<style scoped>

</style>
